import { css } from '@emotion/react';
import { t } from 'i18n';
import type { Option } from 'models';
import { ChangeEvent, useState } from 'react';
import { type BonusProgram, type CodeName } from 'shared';

import { InputField, SelectField } from '../../forms/ui';
import { SasModal } from '../../SasModal';
import { theme } from '../../theme';

import { buttonContainer, buttonOverride } from './styles';

const { spacing, breakpoints, fontWeight } = theme;
const styles = {
  container: css`
    min-width: 700px;
    @media (max-width: ${breakpoints.laptop}) {
      min-width: 0;
    }
  `,
  inputContainer: css`
    display: flex;
    gap: ${spacing.md};
  `,
  originDestinationContainer: css`
    display: flex;
    gap: ${spacing.xs};
  `,
  programInputWrapper: css`
    width: 50%;
  `,
  fontWeightBlack: css`
    font-weight: ${fontWeight.black};
  `,
};

type Props = {
  selected?: BonusProgram | undefined;
  options: Option[];
  origin: CodeName | undefined;
  destination: CodeName | undefined;
  onSave: (selectedBonusProgram: BonusProgram) => void;
  onClose: () => void;
};

export const FrequentFlyerModal = ({ selected, options, origin, destination, onSave, onClose }: Props) => {
  const { container, originDestinationContainer, inputContainer, programInputWrapper } = styles;
  const [bonusProgramKey, setBonusProgramKey] = useState<string>(selected?.bonusProgramKey ?? '');
  const [loyaltyNumber, setLoyaltyNumber] = useState<string>(selected?.loyaltyNumber ?? '');

  const handleButtonSaveOnClick = () => {
    if (bonusProgramKey && loyaltyNumber) {
      onSave({ bonusProgramKey, loyaltyNumber, earnPoints: selected?.earnPoints ?? true });
    }
  };

  return (
    <SasModal open={true} handleClose={onClose}>
      <div css={container}>
        <h3>{t('travelers.ffpTitle')}</h3>
        <div css={originDestinationContainer}>
          <p>
            {origin?.name} <span css={styles.fontWeightBlack}>{origin?.code}</span>
          </p>
          -
          <p>
            {destination?.name} <span css={styles.fontWeightBlack}>{destination?.code}</span>
          </p>
        </div>
        <div css={inputContainer}>
          <div css={programInputWrapper}>
            <SelectField
              options={options}
              tabIndex={1}
              label={t('travelers.ffpTitle')}
              value={bonusProgramKey ? bonusProgramKey : ''}
              onChange={(e: ChangeEvent<HTMLSelectElement>) => setBonusProgramKey(e.target.value)}
            />
          </div>
          <div css={programInputWrapper}>
            {' '}
            <InputField
              value={loyaltyNumber}
              label={t('common:number')}
              tabIndex={2}
              maxLength={16}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                const value = e.target.value.replaceAll(/[^\d]+/g, '');
                setLoyaltyNumber(value);
              }}
            ></InputField>
          </div>
        </div>
        <div css={buttonContainer}>
          <button css={buttonOverride} onClick={onClose} tabIndex={4}>
            {t('common:cancel')}
          </button>
          <button tabIndex={3} onClick={handleButtonSaveOnClick}>
            {t('common:save')}
          </button>
        </div>
      </div>
    </SasModal>
  );
};
